import { addPayTypeApi, storageFileComplete, updatePayTypeApi } from '@/services/signAndPayment';
import { Checkbox, Form, Image, Input, Modal, Radio, Select, Switch, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import { PlusOutlined, CloseCircleFilled } from '@ant-design/icons';
import { useUpload } from '@/hooks';
import './index.less';

interface PayWay {
  name: string;
  code: string;
}
interface PayTypeSupport {
  category: number;
  categoryName: string;
  type: string;
  typeName: string;
  ways: PayWay[];
}
interface ModalProps {
  data: any;
  visible: boolean;
  editType: number;
  payTypeSupported: PayTypeSupport[];
  handleCancel: () => void;
}
const PayTypeModal = (props: ModalProps) => {
  const { data, visible, editType, payTypeSupported, handleCancel } = props;
  const [form] = Form.useForm();
  const [payWays, setPayWays] = useState<PayWay[] | undefined>([]);
  const [iconFile, setIconFile] = useState<any[]>([]);
  const { uploadRequest } = useUpload();
  const payCategory = [
    { label: '在线支付', value: 0 },
    { label: '非在线支付', value: 1 },
  ];

  useEffect(() => {
    const ways =
      editType === 1 ? payTypeSupported?.find((item) => item.type === data?.type)?.ways : [];
    setPayWays(ways);
    if (editType === 1 && data?.iconUrl) {
      setIconFile([{ fileStorageId: data.icon, fileUrl: data.iconUrl }]);
    }
  }, []);

  const onHandleSubmit = async (data: any) => {
    if (editType === 0) {
      const res = await addPayTypeApi(data);
      if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
        message.info('添加成功');
        handleCancel();
      }
    } else {
      const res = await updatePayTypeApi(data.type, data);
      if (res.data && res.data.code === 'SUCCESS' && res.code === 200) {
        message.info('更新成功');
        handleCancel();
      }
    }
  };

  const handleFormSubmit = () => {
    form.validateFields().then(async (values) => {
      onHandleSubmit({
        ...values,
        icon: iconFile && iconFile.length > 0 ? iconFile[0].fileStorageId : '',
      });
    });
  };

  const onPayTypeChange = (e: any) => {
    const payTypeSupport = payTypeSupported.find((item) => item.type === e);
    const ways = payTypeSupported.find((item) => item.type === e)?.ways || [];
    setPayWays(ways);
    form.setFieldValue('name', payTypeSupport?.typeName || '');
    form.setFieldValue('category', payTypeSupport?.category || 0);
  };

  const getBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };
  const uploadFile = (files: any, callback: Function) => {
    uploadRequest({
      url: '/storage/v1/objects/upload/presigned',
      fileStream: files,
      appName: 'order',
      policy: 1,
      srcShortName: files.name,
      srcFileSuffix: files?.name?.split('.')?.pop() ?? 'png',
      srcFullPath: '/app/',
      srcFileSize: files?.size,
      onPreload: () => {},
      onProgress: () => {},
      onSuccess: async (res: any) => {
        const { file, storage } = res ?? {};
        file.fileUrl = await getBase64(file);
        file.fileStorageId = storage?.storageFileId;
        callback?.(file);
        storageFileComplete(storage?.storageFileId);
        // cloudModel.putComplete(storage?.storageFileId);
      },
      onError: async (err: any) => {
        const { exists, file, storage } = err ?? {};
        if (exists) {
          file.fileUrl = await getBase64(file);
          file.fileStorageId = storage?.storageFileId;
          callback?.(file);
          // cloudModel.putComplete(storage?.storageFileId);
        }
      },
    });
  };
  const iconProp = {
    showUploadList: false,
    maxCount: 1,
    accept: '.jpg,.jpeg,.png',
    beforeUpload(f: any) {
      if (iconFile?.length > 1) {
        message.info('最多上传1个文件');
        return false;
      }
      uploadFile(f, (file: any) => {
        setIconFile([file]);
      });
    },
  };

  const deleteIconFile = () => {
    setIconFile([]);
  };

  return (
    <Modal
      open={visible}
      title={editType === 1 ? '编辑支付类型' : '新增支付类型'}
      maskClosable={false}
      onCancel={handleCancel}
      onOk={handleFormSubmit}
    >
      <Form
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        style={{ maxWidth: 600 }}
        form={form}
        initialValues={data}
      >
        <Form.Item
          label="支付类型标识"
          name="type"
          rules={[{ required: true, message: '请输入支付类型标识' }]}
        >
          <Select
            disabled={editType === 1}
            placeholder="请选择支付类型标识"
            onChange={onPayTypeChange}
          >
            {payTypeSupported.map((item) => {
              return (
                <Select.Option key={item.type} value={item.type}>
                  {item.type}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
        <Form.Item
          label="支付类型名称"
          name="name"
          rules={[{ required: true, message: '请输入支付类型名称' }]}
        >
          <Input maxLength={20} placeholder="请输入支付类型名称" />
        </Form.Item>
        <Form.Item
          label="是否在线支付"
          name="category"
          rules={[{ required: true, message: '请选择是否在线支付' }]}
        >
          <Radio.Group>
            {payCategory.map((item) => {
              return (
                <Radio key={item.value} value={item.value}>
                  {item.label}
                </Radio>
              );
            })}
          </Radio.Group>
        </Form.Item>
        <Form.Item label="支付类型图标" name="icon">
          {iconFile && iconFile.length > 0 ? (
            <div className="iconFile">
              <CloseCircleFilled className="closeIcon" onClick={deleteIconFile} />
              <Image height={100} src={iconFile[0].fileUrl} />
            </div>
          ) : (
            <Upload {...iconProp} listType="picture-card">
              <div>
                <PlusOutlined />
              </div>
            </Upload>
          )}
        </Form.Item>
        <Form.Item
          label="支付方式"
          name="ways"
          rules={[{ required: true, message: '请选择支付方式' }]}
        >
          {payWays && payWays.length > 0 ? (
            <Checkbox.Group
              options={payWays?.map((item) => {
                return { label: item.name, value: item.code };
              })}
            />
          ) : (
            '请先选择支付类型'
          )}
        </Form.Item>
        <Form.Item label="商户模式" name="mchMode">
          <Switch checkedChildren="启用" unCheckedChildren="禁用" defaultChecked={data.mchMode} />
        </Form.Item>
        <Form.Item label="服务商模式" name="ispMode">
          <Switch checkedChildren="启用" unCheckedChildren="禁用" defaultChecked={data.ispMode} />
        </Form.Item>
        <Form.Item label="描述" name="description">
          <Input.TextArea maxLength={100} placeholder="支付类型描述" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default PayTypeModal;
